import { render, staticRenderFns } from "./SkupKotizacijaForma.vue?vue&type=template&id=2d7f323c&scoped=true&"
import script from "./SkupKotizacijaForma.vue?vue&type=script&lang=js&"
export * from "./SkupKotizacijaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f323c",
  null
  
)

export default component.exports